import classNames from "classnames";
import React from "react";

export type CaTableCaptionProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLTableCaptionElement>,
  HTMLTableCaptionElement
>;

function CaTableCaption({ className, ...props }: CaTableCaptionProps) {
  return <caption className={classNames("p-6 text-sm text-mid-neutral-1", className)} {...props} />;
}

export default CaTableCaption;
